module.exports = __webpack_public_path__ + "img/prev.357c742d.svg";